import React from "react"
import { Row, Col, Button, Input } from "reactstrap"
import { useTranslation } from "react-i18next"

interface ServerPaginationProps {
  pageIndex: number
  totalPages: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  onPageChange: (pageIndex: number) => void
}

export const ServerPagination: React.FC<ServerPaginationProps> = ({
  pageIndex,
  totalPages,
  hasPreviousPage,
  hasNextPage,
  onPageChange,
}) => {
  const { t } = useTranslation()
  const [inputValue, setInputValue] = React.useState(pageIndex)

  React.useEffect(() => {
    setInputValue(pageIndex)
  }, [pageIndex])

  return (
    <Row className="justify-content-md-end justify-content-center align-items-center mt-3">
      <Col className="col-md-auto">
        <div className="d-flex gap-1">
          <Button
            color="primary"
            onClick={() => onPageChange(0)}
            disabled={!hasPreviousPage}
          >
            {"<<"}
          </Button>
          <Button
            color="primary"
            onClick={() => onPageChange(pageIndex - 1)}
            disabled={!hasPreviousPage}
          >
            {"<"}
          </Button>
        </div>
      </Col>
      <Col className="col-md-auto d-none d-md-block">
        {t("common_page")}{" "}
        <strong>
          {pageIndex } {t("common_of")} {totalPages}
        </strong>
      </Col>
      <Col className="col-md-auto">
        <Input
          type="number"
          min={1}
          style={{ width: 70 }}
          max={totalPages}
          value={inputValue}
          onChange={e => {
            const val = e.target.value ? Number(e.target.value) - 1 : 1
            setInputValue(val)
            const page = val - 1
            if (page >= 0 && page < totalPages) {
              onPageChange(page)
            }
          }}
        />
      </Col>

      <Col className="col-md-auto">
        <div className="d-flex gap-1">
          <Button
            color="primary"
            onClick={() => onPageChange(pageIndex + 1)}
            disabled={!hasNextPage}
          >
            {">"}
          </Button>
          <Button
            color="primary"
            onClick={() => onPageChange(totalPages - 1)}
            disabled={!hasNextPage}
          >
            {">>"}
          </Button>
        </div>
      </Col>
    </Row>
  )
}

export default ServerPagination
